const cn = {
  login: '로그인',
  signUp: '회원 가입',
}

export default cn
